<div class="card panel-flat-color secondary-panel">
    <div class="panel-flat-header" style="display: flex; justify-content: space-between">
        <h3>Available Collectors</h3>
        <div class="header-button-container">
            @if (!editMode && hasWritePermission) {
                <button class="ace-btn btn-text has-icon btn-primary"
                        (click)="edit()">
                    <i class="fa fa-pencil"></i>
                </button>
            }
            @if (editMode) {
                <span>
          <button class="ace-btn btn-text has-icon btn-primary btn-success" (click)="save()">
            <i class="fa fa-save"></i>
          </button>
          <button class="ace-btn btn-text has-icon btn-primary btn-danger" (click)="cancel();">
            <i class="fa fa-close"></i>
          </button>
        </span>
            }
        </div>
    </div>
    <div id="collector-scroll-panel" class="panel-flat-body">
        <ws-ace-loader [show]="serverAction" [size]="4" [hasOverlay]="true"></ws-ace-loader>
        @if (editMode) {
            <div style="margin-bottom: 10px;">
                <div class="ws-flex-container-horizontal" style="align-items: center; justify-content: center; gap: 10px;">
                    <div class="form-group-sm ws-flex-none ws-flex-container-horizontal"
                         style="align-items: center; gap: 5px;">
                        <span class="ws-font-weight-normal ws-flex-none">State:</span>
                        <state-dropdown class="ws-flex-none"
                                        style="padding: 2px;"
                                        [stateId]="state.stateID"
                                        [filterByCountryId]="state.countryId"
                                        (stateIdChange)="loadAvailableCollectors($event)"
                                        [disabled]="loadingAvailableCollectors"
                                        container="#collector-scroll-panel">
                        </state-dropdown>
                    </div>
                    <ws-select placeholder="Add Collector"
                               [(ngModel)]="newCollector"
                               [isLoading]="loadingAvailableCollectors"
                               (selectedOptionChanged)="addAssociation()"
                               [options]="filteredStateCollectors"
                               labelProperty="abbr"
                               [returnEntireOption]="true"
                               container="#collector-scroll-panel"
                               searchType="substring">
                    </ws-select>
                </div>
            </div>
        }
        <table class="table table-condensed table-striped">
            <thead>
            <tr>
                <th>Default</th>
                <th>Collector</th>
                <th>State</th>
                <th></th>
            </tr>
            </thead>
            <tbody>
                @for (collector of collectorAssociations; track collector) {
                    <tr>
                        <td>
                            <input type="checkbox" [disabled]="!editMode" [(ngModel)]="collector.isDefault"/>
                        </td>
                        <td>
                            @if (!editMode) {
                                <a
                                    anchor-route
                                    [sref]="{ target: 'collector', options: { stateId: state.stateID, stateCollectorId: collector.collectorID } }">
                                    {{ collector.collector.abbr }}
                                </a>
                            }
                            @if (editMode) {
                                <span>{{ collector.collector.abbr }}</span>
                            }
                        </td>
                        <td>{{ collector.stateAbbr }}</td>
                        <td>
                            @if (editMode) {
                                <button class="ace-btn has-icon btn-primary btn-danger"
                                        (click)="removeAssociation(collector)">
                                    <i class="fa fa-trash"></i>
                                </button>
                            }
                        </td>
                    </tr>
                }
            </tbody>
        </table>
    </div>
</div>
